module.exports = __webpack_public_path__ + "static/img/topImg.ea5f833.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/statistics-charts/insurance-statistics/images/topImg.png
// module id = KUgc
// module chunks = 183